module.exports = __webpack_public_path__ + "img/thumb-tiny-image-3.e6e72695.png";